import { useQuery } from 'react-query';
import { getOrderStatistics } from 'features/dashboard/api';

export const useOrderStatisticsQuery = () => {
  const result = useQuery(
    `order-statistics`,
    async () => {
      const { data } = await getOrderStatistics();
      return data;
    },
    { staleTime: Infinity }
  );

  return result;
};
